export function formatYYYYMMDD(t) {
  const year = t.getFullYear();
  const month = ((t.getMonth() + 1 < 10) ? '0' : '') + (t.getMonth() + 1);
  const day = ((t.getDate() < 10) ? '0' : '') + t.getDate();
  return year + '-' + month + '-' + day
}

export default function (t) {
  if (!t) return '';

  t = new Date(t);
  const now = new Date();

  const tStartOfDay = new Date(t)
  tStartOfDay.setUTCHours(0, 0, 0, 0);
  const nowStartOfDay = new Date(now)
  nowStartOfDay.setUTCHours(0, 0, 0, 0);

  const diff = (nowStartOfDay - tStartOfDay) / (24 * 60 * 60 * 1000);
  //console.info('dateTimeSameHuman | t = ', t, ' | diff = ', diff);

  const year = t.getFullYear();
  const month = t.getMonth() + 1;
  const day = t.getDate();
  const hour = (t.getHours() < 10 ? '0' : '') + t.getHours();
  const minute = (t.getMinutes() < 10 ? '0' : '') + t.getMinutes();

  switch (diff) {
    case 0:
      return (
        this.$t('home.date_time_same_today') + ' ' +
        hour + ':' + minute
      );
    case 1:
      return (
        this.$t('home.date_time_same_yesterday') + ' ' +
        hour + ':' + minute
      );
    default :
      return (
        day + ' ' +
        this.$t('home.mon_' + month) + ' ' +
        (now.getFullYear() !== t.getFullYear() ? year + ' ' : '') +
        hour + ':' + minute
      );
  }
}
